<template>
  <el-select :value="valueTitle"
             :clearable="clearable"
             @clear="clearHandle"
             :popper-append-to-body="popperAppendToBody"
             :disabled="disabled"
             ref="treeSelect">
    <el-input class="selectInput"
              :placeholder="placeholder"
              v-model="filterText">
    </el-input>
    <el-option :value="valueTitle"
               :label="valueTitle"
               class="options">
      <el-scrollbar style="height:200px">
        <el-tree id="tree-option"
                ref="selectTree"
                :default-expand-all="true"
                :accordion="accordion"
                 :data="options"
                 :props="config"
                 :node-key="config.value"
                 :default-expanded-keys="defaultExpandedKey"
                 :filter-node-method="filterNode"
                 @node-click="handleNodeClick">
        </el-tree>
      </el-scrollbar>
    </el-option>
  </el-select>
</template>
<script>
//default-expand-all="true"
import emitter from 'element-ui/src/mixins/emitter' // 分发事件的el-form处理方法
export default {
  mixins: [emitter],
  name: 'SelectTree',
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          // soleValue:'mineCode',
          value: 'id', // ID字段名
          label: 'deptName', // 显示名称
          children: 'children', // 子级字段名
        }
      },
      required: true,
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => {
        return []
      },
    },
    /* 初始值 */
    value: {
      default: () => {
        return null
      },
    },
    /* 可清空选项 */
    clearable: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    formData: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      },
    } /* 自动收起 */,
    accordion: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    placeholder: {
      type: String,
      default: () => {
        return '检索关键字'
      },
    },
    popperAppendToBody:{
      type: Boolean,
      default: () => {
        return true
      },
    }
  },
  data() {
    return {
      filterText: '',
      valueId: this.value, // 初始值
      valueTitle: '',
      defaultExpandedKey: [],
    }
  },
  mounted() {
    this.initHandle()
  },
  methods: {
    // 初始化值
    initHandle() {
      if (this.valueId) {
        this.$nextTick(() => {
          this.valueTitle =
            this.$refs.selectTree.getNode(this.valueId) &&
            this.$refs.selectTree.getNode(this.valueId).data[this.config.label] // 初始化显示
          this.$refs.selectTree.setCurrentKey(this.valueId) // 设置默认选中
          this.defaultExpandedKey = [this.valueId] // 设置默认展开
        })
      }
      this.initScroll()
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          '.el-scrollbar .el-select-dropdown__wrap'
        )[0]
        let scrollBar = document.querySelectorAll(
          '.el-scrollbar .el-scrollbar__bar'
        )
        scrollWrap.style.cssText =
          'margin: 0px; max-height: none; overflow: hidden;'
        scrollBar.forEach((ele) => (ele.style.width = 0))
      })
    },
    // 切换选项
    handleNodeClick(node) {
      this.valueTitle = node[this.config.label]
      this.valueId = node[this.config.value]
      this.value = node[this.config.value]
      this.dispatch('ElFormItem', 'el.form.change', this.valueId)
      this.defaultExpandedKey = []
      if (!node.children || !node.children.length) {
        //补录选择完选项弹框不能收起
        this.$refs.treeSelect.blur()
      }
      this.$emit('getValue', this.valueId)
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = ''
      this.valueId = null
      this.value = null
      this.defaultExpandedKey = []
      this.clearSelected()
      this.dispatch('ElFormItem', 'el.form.change', null)
      this.$emit('getValue', undefined)
    },
    /* 清空选中样式 */
    clearSelected() {
      let allNode = document.querySelectorAll('#tree-option .el-tree-node')
      allNode.forEach((element) => element.classList.remove('is-current'))
    },
    filterNode(value, data) {
      if (!value) return true
      return data[`${this.config.label}`].indexOf(value) !== -1
    }
  },
  watch: {
    value(val) {
      this.$emit('input', val || null)
      // this.formData[this.config.soleValue] = this.val
      this.dispatch('ElFormItem', 'el.form.change', val)
      this.valueId = this.value
      this.initHandle()
    },
    filterText(val) {
      this.$refs.selectTree.filter(val)
    },
    valueTitle(val) {
      this.dispatch('ElFormItem', 'el.form.change', val)
    },
  },
}
</script>
